import m3 from "./m3";
import { Camera } from "./camera";
import { TileManager } from "./tileManager";
import { SvtManager, TileInfo } from "./svtManager";
import { Renderer } from "./renderer";
import { DebugRenderer } from "./debugRenderer";

const fpsText = document.getElementById("fpsText") as HTMLDivElement;

// Debug canvas
const debugCanvasContainer = document.getElementById("debugCanvasContainer") as HTMLDivElement;
const debugCanvas = document.getElementById("debugCanvas") as HTMLCanvasElement;
const debugText = document.getElementById("debugText") as HTMLDivElement;
const debugGl = debugCanvas.getContext("webgl2")!;
if (!debugGl.getExtension('EXT_color_buffer_float')) {
    console.error('EXT_color_buffer_float is not supported.');
}
// if (!debugGl.getExtension('OES_texture_float_linear')) {
//     console.error('OES_texture_float_linear is not supported.');
// }
debugCanvas.width = 512;
debugCanvas.height = 512;

// Main canvas
const canvas = document.getElementById("canvas") as HTMLCanvasElement;
const gl = canvas.getContext("webgl2")!;
gl.canvas.width = window.innerWidth;
gl.canvas.height = window.innerHeight;
gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);

if (!gl.getExtension('EXT_color_buffer_float')) {
    alert('EXT_color_buffer_float is not supported.');
}
// if (!gl.getExtension('OES_texture_float_linear')) {
//     alert('OES_texture_float_linear is not supported.');
// }
if (!gl.getExtension('EXT_texture_filter_anisotropic')) {
    alert('EXT_texture_filter_anisotropic is not supported.');
}

const TILE_SIZE = 1024;
const QUAD_SIZE = 1024;
const ATLAS_SIZE = 6144;
const SVT_DEPTH = 5;
const SVT_RESOLUTION: [number, number] = [TILE_SIZE * (2 ** SVT_DEPTH), TILE_SIZE * (2 ** SVT_DEPTH)];

const camera = new Camera(canvas);
const tileManager = new TileManager(400);
const debugRenderer = new DebugRenderer(debugGl, tileManager, TILE_SIZE, ATLAS_SIZE);
const svtManager = new SvtManager(gl, tileManager, TILE_SIZE, ATLAS_SIZE, SVT_DEPTH);
const renderer = new Renderer(gl, QUAD_SIZE, TILE_SIZE, SVT_DEPTH, SVT_RESOLUTION);

fpsText.style.display = "block";
debugText.style.display = "block";
        
let isDebug = true;
let hoveredPixel = [0, 0];

var frames = 0;
var startTime = performance.now();
var FPSNormal = 0;

function calculateFPSNormal() {
	var t = performance.now();
	var dt = t - startTime;

	if( dt > 1000 ) {
		FPSNormal = frames * 1000 / dt;
		frames = 0;
		startTime = t;
	}
	frames++;
}

function draw(now): void {
    // if (frames % 30 === 0) {
        const visibleTiles = renderer.detectVisibleTiles(camera);
        for (const tileId of visibleTiles) {
            const tilePath = `/tiles/${tileId}.jpg`;
            svtManager.scheduleTileUpload(tileId, tilePath);
            // if (!svtManager.hasTile(tileId)) {
            //     // if (isDebug) debugRenderer.updateTexture(tileId, tilePath, layerIndex);
            // } else {
            //     svtManager.setLastAccessed(tileId, Date.now());
            // }
        }
    // }
    svtManager.processUploadQueue(1);
    // if (isDebug) debugRenderer.render();
    renderer.draw(camera, svtManager, isDebug, hoveredPixel);
    calculateFPSNormal();
    fpsText.textContent = FPSNormal.toFixed(1);
    requestAnimationFrame(draw);
}

// Event listeners
canvas.addEventListener("mousedown", camera.onMouseDown(() => { }));
canvas.addEventListener("wheel", camera.onWheel(() => { }));
canvas.addEventListener("mousemove", (e) => {
    const [clipX, clipY] = camera.getClipSpaceMousePosition(e);
    const invMat = m3.inverse(camera.getViewProjectionMat());
    hoveredPixel = m3.transformPoint(invMat, [clipX, clipY]);
    debugText.innerText = `[${Math.floor(hoveredPixel[0])}, ${Math.floor(hoveredPixel[1])}]`;
    // draw();
});
document.addEventListener("keydown", (e) => {
    if (e.key === "d") {
        isDebug = !isDebug;
        // debugCanvasContainer.style.display = isDebug ? "block" : "none";
        fpsText.style.display = isDebug ? "block" : "none";
        debugText.style.display = isDebug ? "block" : "none";
        // draw();
    }
});

window.addEventListener("beforeunload", (e) => {
    tileManager.clearTiles() // Clear tiles from DB on window close
});

async function init(): Promise<void> {
    const level0TileId = "level0/tx_0_0";
    const tileInfo: TileInfo = { tileId: level0TileId, layerIndex: 0, lastAccessed: Date.now(), level: 0, col: 0, row: 0 };
    const image = await svtManager.uploadTileNow(level0TileId, `/tiles/${level0TileId}.jpg`, tileInfo);
    // svtManager.setLastAccessed(level0TileId, Infinity);
    // debugRenderer.updateTexture(level0TileId, `/tiles/${level0TileId}.png`, 0);
    requestAnimationFrame(draw);
}

init();